import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './locales/es/common.json';
import en from './locales/en/common.json';
import { brand } from '../config/brand';

/**
 * i18n initialisation.
 *
 * - URL-path detection is the primary signal (locale-prefixed routes).
 * - Falls back to navigator language, then `es` (default).
 * - `returnNull: false` so missing keys fall through to their English value
 *   instead of rendering `null` (easier to spot in dev).
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { common: es },
      en: { common: en },
    },
    fallbackLng: brand.defaultLocale,
    supportedLngs: brand.locales as unknown as string[],
    defaultNS: 'common',
    ns: ['common'],
    interpolation: { escapeValue: false },
    returnNull: false,
    detection: {
      order: ['path', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
      caches: [],
    },
  });

export default i18n;
